import WeatherLocationId from 'owa-service/lib/contract/WeatherLocationId';
import TemperatureUnit from 'owa-service/lib/contract/TemperatureUnit';

export function getWeatherServiceUrl(
    unit: TemperatureUnit,
    weatherLocationIds?: WeatherLocationId[]
): string {
    const days = 5;
    const temperatureUnit = unit === TemperatureUnit.Celsius ? 'C' : 'F';
    const ids = weatherLocationIds.map(val => val.EntityId).join(',');
    let url = `ows/beta/WeatherService/forecast/?Service=summary&Days=${days}&Units=${temperatureUnit}&Ids=${ids}`;
    return url;
}
